import React from "react";
import {
  Header,
  Nav,
  About,
  Experience,
  Portfolio,
  Testimonials,
  Contact,
  Footer,
} from "./components/index";

const App = () => {
  return (
    <>
      <Header />
      <Nav />
      <About />
      <Experience />
      <Portfolio />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  );
};

export default App;
